import React from 'react';
import { get } from 'lodash';
import * as Types from '@components/filter/types';
import * as Styled from './styled';

export type CategoryOptions = {
  originalLabel: string;
  label: React.ReactNode;
  options: {
    originalLabel: string;
    label: React.ReactNode;
    value: string;
  }[];
}[];

export const getCategoryOptions = (filterMeta: Types.FilterMeta): CategoryOptions => {
  const { categories } = filterMeta;
  return Object.entries(categories)
    .map(([category = '', subCategories]) => {
      return {
        originalLabel: category,
        label: category,
        options: subCategories
          .map((it) => ({
            originalLabel: String(it ?? ''),
            label: (<Styled.CategoryLabel>{it}</Styled.CategoryLabel>) as React.ReactNode,
            value: `${category}/${it}`,
          }))
          .sort((a, b) => a.originalLabel.localeCompare(b.originalLabel)),
      };
    })
    .sort((a, b) => a.originalLabel.localeCompare(b.originalLabel));
};

export const getMatchedCategory = (
  firstRuleField: string | undefined,
  filterMeta: Types.FilterMeta,
  categoryOptions = getCategoryOptions(filterMeta),
) => {
  const defaultSubCategory = get(categoryOptions, '[0].options[0].value');

  try {
    const parentDimensionsMeta = filterMeta.dimensions.find((d) =>
      d.fields.some((it) => it.value === firstRuleField),
    );
    const fieldMeta = parentDimensionsMeta?.fields.find((it) => it.value === firstRuleField);

    if (!parentDimensionsMeta || !fieldMeta) return defaultSubCategory;

    for (let i = 0; i < categoryOptions.length; i++) {
      const targetCategory = categoryOptions[i];
      // check if subcategory matched
      const matchedSubcategory = targetCategory.options.find(
        (it) => (fieldMeta.name || '').toLowerCase() === it.originalLabel.toLowerCase(),
      );
      if (matchedSubcategory) return matchedSubcategory.value;

      // check if category matched
      if (
        parentDimensionsMeta.name.toLowerCase().includes(targetCategory.originalLabel.toLowerCase())
      ) {
        return targetCategory.options[0].value;
      }
    }
  } catch (e) {
    // do nothing
  }

  return defaultSubCategory;
};
